"use client"

import { useEffect, useState } from "react"

interface ViewCounterProps {
  storyId: string
}

export default function ViewCounter({ storyId }: ViewCounterProps) {
  const [viewCount, setViewCount] = useState<number | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchViewCount = async () => {
      try {
        const response = await fetch(`/api/view-count/${storyId}`)
        if (response.ok) {
          const data = await response.json()
          setViewCount(data.viewCount)
        }
      } catch (error) {
        console.error("Failed to fetch view count:", error)
      } finally {
        setLoading(false)
      }
    }

    void fetchViewCount()
  }, [storyId])

  // Don't render anything while loading or if there's no count
  if (loading || viewCount === null) {
    return null
  }

  return (
    <span className="text-xs text-gray-500">
      {viewCount} {viewCount === 1 ? "view" : "views"}
    </span>
  )
}
